import React from "react";
import { FilterBadge, FilterBadgeContainer } from "./ListStyles";

/**
 * Filter badges component for list filtering
 * @param {{
 *   options: Array<string | { label: string, value: string }>,
 *   activeFilter: string,
 *   onFilterChange: (filter: string) => void,
 * }} props
 */
export const FilterBadges = ({ options, activeFilter, onFilterChange }) => {
  return (
    <FilterBadgeContainer>
      {options.map((opt) => {
        const isObjectOption = typeof opt === "object" && opt !== null;
        const label = isObjectOption ? opt.label : opt;
        const value = isObjectOption ? opt.value : opt;

        return (
          <FilterBadge
            key={`${value}-${label}`}
            active={activeFilter === value}
            onClick={() => onFilterChange(value)}
          >
            {label}
          </FilterBadge>
        );
      })}
    </FilterBadgeContainer>
  );
};

export default FilterBadges;
